import { defineMessages } from 'react-intl';

export default defineMessages({
  NO_ACHIEVEMENTS: {
    defaultMessage: 'Aucun badge pour le moment.',
  },

  EMPTY_STATE_TOOLTIP_CONTENT: {
    defaultMessage: 'Vos nouveaux badges s’afficheront ici',
  },
} as const);
